import DayPartWeekly from "./day-part/day-part-weekly";
import DayPartDaily from "./day-part/day-part-daily";
import DayPartMonthly from "./day-part/day-part-monthly";
import DayPartYearly from "./day-part/day-part-yearly";

export const classesMap = {
  weekly: DayPartWeekly,
  mon_to_fri: DayPartWeekly,
  mon_wed_fri: DayPartWeekly,
  tue_thu: DayPartWeekly,
  daily: DayPartDaily,
  monthly: DayPartMonthly,
  yearly: DayPartYearly
};

class DayPartsFactory {
  static createDayPart(props, timezone) {
    //temporary fix for MO-321
    if (!classesMap[props.repeatTemplate] || !props.eventDefinition.repeat) {
      return new DayPartDaily({ ...props, timezone });
    }
    return new classesMap[props.repeatTemplate]({ ...props, timezone });
  }
}

export default DayPartsFactory;
